import React from 'react';
import {Link} from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const AboutPage = () => {
  return (
    <Sidebar>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">O aplikacji</h1>
        
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Informacje o aplikacji</h2>
          <p className="mb-4">
            Ta aplikacja służy do zarządzania kampaniami phishingowymi w celach edukacyjnych i testowych.
            Umożliwia tworzenie scenariuszy, zarządzanie szablonami e-mail oraz monitorowanie kampanii.
          </p>
          <p className="mb-4">
            Wersja: 0.0.1
          </p>
        </div>
        
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Przydatne linki</h2>
          <ul className="space-y-2">
            <li>
              <Link to="/roadmap" className="text-blue-600 hover:text-blue-800 font-medium">
                Roadmap
              </Link>
              <span className="text-gray-500 ml-2">- plany rozwoju aplikacji</span>
            </li>
          </ul>
        </div>
      </div>
    </Sidebar>
  );
};

export default AboutPage; 